module.exports = __webpack_public_path__ + "img/HD_title_zyq_1_850fbfeac.png";